var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FieldCollapse',{attrs:{"allOpen":_vm.open,"data":_vm.data,"fields":_vm.collapsedField},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
var fields = ref.fields;
return [_c('Fieldset',{attrs:{"data":data,"fields":fields,"borderless":true,"invert":_vm.invert},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return _vm._l((data),function(file){return _c('div',{key:file.file,staticClass:"field column"},[_c('div',{staticClass:"value"},[_c('a',{attrs:{"href":file.url,"alt":file.file}},[_vm._v(" "+_vm._s(file.file)+" ")])])])})}}],null,true)})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }